module.exports = __webpack_public_path__ + "static/media/Interstate-Light.e47060dd.otf";